<template>
  <div class="select-unsplash-modal">
    <HMModalHeader :title="$t(title)" @close="$emit('close')" />
    <div class="container">
      <div class="row">
        <div class="col-12 p-0">
          <HMSearch v-model="search" @input="searchNewImages" />
        </div>
        <div class="col-12 p-0">
          <hr class="mt-4 mb-2" />
          <span class="d-block w-100 text-right smallest"
            >{{ $t('GENERAL.LABEL.POWERED_BY') }}
            <a
              target="_blank"
              href="https://unsplash.com/?utm_source=Namastream&utm_medium=referral"
              >Unsplash</a
            ></span
          >
        </div>
        <div
          class="col-12 p-0 d-flex flex-row justify-content-between flex-wrap mt-4"
        >
          <figure
            class="unsplash-image-container pt-2"
            v-for="image in foundImages"
            :key="image.id"
            @click="selectImage(image)"
          >
            <img :src="image.urls.thumb" class="img-thunbmail" />
            <figcaption class="smallest">
              {{ $t('GENERAL.LABEL.PHOTO_BY') }}
              <a
                target="_blank"
                :href="`https://unsplash.com/@${image.user.username}?utm_source=Namastream&utm_medium=referral`"
                >{{ image.user.name }}</a
              >
            </figcaption>
          </figure>
        </div>
        <div
          class="col-12 p-0 text-center mt-4 w-100"
          v-if="foundImages.length > 0"
        >
          <HMButton
            color="brand"
            class="w-100"
            @click="loadMore"
            :loading="isLoading"
            :disabled="isLoading"
          >
            <span class="w-100 text-center">{{
              $t('GENERAL.BUTTON.LOAD_MORE')
            }}</span>
          </HMButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorToMessage } from '@/core/utils/errors';

const PAGE_SIZE = 30; // max = 30

export default {
  name: 'HMUnsplashImageSelectModal',
  components: {},
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.FIND_AND_SELECT_IMAGE',
    },
    onSelect: { type: Function },
  },
  data() {
    return {
      search: '',
      foundImages: [],
      currentPage: 1,
      isLoading: false,
    };
  },
  methods: {
    selectImage(image) {
      this.$store.dispatch('mediaLibrary/unsplashMarkDownload', {
        downloadUrl: image.links.download_location,
      });
      this.onSelect(image);
      this.$emit('close');
    },
    searchNewImages() {
      this.searchImages(true);
    },
    async searchImages(clearOldSearch) {
      this.isLoading = true;
      try {
        const images = await this.$store.dispatch(
          'mediaLibrary/searchUnsplashImages',
          {
            query: this.search,
            page: this.currentPage,
            pageSize: PAGE_SIZE,
          }
        );
        if (clearOldSearch) {
          this.foundImages = images;
        } else {
          this.foundImages = [...this.foundImages, ...images];
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load images from Unsplash',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
    loadMore() {
      this.currentPage += 1;
      this.searchImages(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.unsplash-image-container {
  position: relative;
  display: flex;
  margin: 4px 4px;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    figcaption {
      opacity: 0.7;
    }
  }

  .img-thunbmail {
    object-fit: cover;
    object-position: 50% 50%;
    height: 150px;
    width: auto;
  }

  figcaption {
    position: absolute;
    width: 100%;
    text-align: center;
    left: 0;
    bottom: 0;
    text-shadow: 0 0 1px white;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    background-color: $light-gray;
    overflow: hidden;
  }
}
</style>
